import api from './api';

export const phonebookService = {
  // Get all phonebook entries (with vendor scoping, search, filters)
  getPhonebook: async (params = {}) => {
    const response = await api.get('/phonebook', { params });
    return response.data;
  },

  // Get phonebook statistics
  getStats: async () => {
    const response = await api.get('/phonebook/stats');
    return response.data;
  },

  // Sync phonebook from all sources (admin only)
  syncPhonebook: async () => {
    const response = await api.post('/phonebook/sync');
    return response.data;
  },

  // Create a manual phonebook entry
  createManualEntry: async (data) => {
    const response = await api.post('/phonebook/manual', data);
    return response.data;
  },

  // Update a manual entry
  updateEntry: async (id, data) => {
    const response = await api.put(`/phonebook/${id}`, data);
    return response.data;
  },

  // Delete an entry
  deleteEntry: async (id) => {
    const response = await api.delete(`/phonebook/${id}`);
    return response.data;
  },

  // --- UPGRADED: Added imageUrl support ---
  bulkWhatsApp: async (contactIds, message, imageUrl = '') => {
    const response = await api.post('/phonebook/bulk-whatsapp', {
      contactIds,
      message,
      imageUrl,
    });
    return response.data;
  },
};

export default phonebookService;